// Deep-links into the "Billing diagnosis" Axiom dashboard.
// Dashboard definition: ai-docs/axiom/dashboards/billing-diagnosis-dashboard.json
// The v_* params map to the dashboard's SmartFilter ids (user_id_search / reference_id_search).
const BILLING_DASHBOARD_URL =
  'https://app.axiom.co/little-bird-uv1s/dashboards/FFs2O3dGP4VkeGK8pu';

interface BillingUrlParams {
  userId?: number | string | null;
  referenceId?: string | null;
}

export function buildAxiomBillingUrl({
  userId,
  referenceId,
}: BillingUrlParams): string {
  const params = new URLSearchParams();
  if (userId != null && `${userId}` !== '') {
    params.set('v_user_id_search', `${userId}`);
  }
  if (referenceId) {
    params.set('v_reference_id_search', referenceId);
  }
  const query = params.toString();
  return query ? `${BILLING_DASHBOARD_URL}?${query}` : BILLING_DASHBOARD_URL;
}
